import { Component, OnInit } from '@angular/core';
import { Product } from '../../interfaces/product';
import { MatChipInputEvent } from '@angular/material';
import { ProductsService } from '../../services/products.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { TranslateService } from '@ngx-translate/core';
import { LoyalizationService } from '../../services/loyalization.service';
import { LoyalizationFeeInterface } from '../../interfaces/loyalization-fee.interface';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-loyalization',
  templateUrl: './loyalization.component.html',
  styleUrls: ['./loyalization.component.scss']
})
export class LoyalizationComponent implements OnInit {
  public products: Product[];
  public loyalizationTable = 'loyalizationTable';
  public productTable = 'productTable';
  public loyalizationPeriods = [];
  loyalizationFee: FormControl = new FormControl(null, [Validators.required]);
  isLoyalizationFeeLoading = false;
  isLoyalizationPeriodsLoading = false;
  isLoyalizationFeeSubmitting = false;
  isLoyalizationPeriodsSubmitting = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastsManager,
    public translate: TranslateService,
    private loyalizationService: LoyalizationService
  ) {}

  ngOnInit() {
    this.isLoyalizationPeriodsLoading = true;
    this.loyalizationService.getLoyalizationPeriods().subscribe(periods => {
      this.loyalizationPeriods = periods;
      this.isLoyalizationPeriodsLoading = false;
    });

    this.isLoyalizationFeeLoading = true;
    this.loyalizationService.getLoyalizationFee().subscribe(({ loyalizationFee }: LoyalizationFeeInterface) => {
      this.loyalizationFee.setValue(loyalizationFee);
      this.isLoyalizationFeeLoading = false;
    });

    this.loyalizationService
      .getLoyalizationFee()
      .subscribe(({ loyalizationFee }: LoyalizationFeeInterface) => this.loyalizationFee.setValue(loyalizationFee));
  }

  saveLoyalizationPeriods() {
    this.isLoyalizationPeriodsSubmitting = true;

    this.loyalizationService.createLoyalizationPeriods(this.loyalizationPeriods.sort((a, b) => a - b)).subscribe(
      () => {
        this.toastr.info(this.translate.instant('LOYALIZATION.COMPONENT.FEE_SAVING_SUCCESS'));
        this.isLoyalizationPeriodsSubmitting = false;
      },
      () => {
        this.toastr.info(this.translate.instant('LOYALIZATION.COMPONENT.FEE_SAVING_FAIL'));
        this.isLoyalizationPeriodsSubmitting = false;
      }
    );
  }

  saveLoyalizationFee() {
    this.isLoyalizationFeeSubmitting = true;

    this.loyalizationService.setLoyalizationFee(this.loyalizationFee.value).subscribe(
      () => {
        this.toastr.info(this.translate.instant('LOYALIZATION.COMPONENT.LOYALTY_PERIOD_SAVED'));
        this.isLoyalizationFeeSubmitting = false;
      },

      () => {
        this.toastr.info(this.translate.instant('LOYALIZATION.COMPONENT.LOYALTY_PERIOD_FAILED'));
        this.isLoyalizationFeeSubmitting = false;
      }
    );
  }

  public inputValidator(event): void {
    const pattern = /^[1-9][0-9]*$/;
    if (!pattern.test(event.target.value)) {
      event.target.value = event.target.value = '';
    }
  }

  addTag(event: MatChipInputEvent, array: string[]): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      array.push(value.trim());
    }

    if (input) {
      input.value = '';
    }
  }

  removeTag(tag: any, array: string[]): void {
    const index = array.indexOf(tag);

    if (index >= 0) {
      array.splice(index, 1);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/loyalization/loyalization.component.ts